module.exports = __webpack_public_path__ + "assets/img/abta.d57d4866.png";